import QrPayCore from '../shared/qr-pay-core.js';
import { cleanupBootstrapModalBody } from '../shared/bootstrap-modal-cleanup.js';
import { getMemberOverlayElement, hideOverlay } from '../shared/overlay.js';
import { memberLogOut } from './donation-flow-nav.js';
import { showAlertMsg } from './member-show-alert-msg.js';

let qrPayModal = null;

export function openQrPayModal() {
    if (!qrPayModal) {
        throw new Error('qr-pay-modal: initQrPayModal must be called before opening the QR payment modal');
    }
    qrPayModal.open();
}

export function initQrPayModal() {
    const configEl = document.getElementById('qr-pay-modal-config');
    if (!configEl?.textContent) {
        throw new Error('qr-pay-modal: missing qr-pay-modal-config');
    }

    let cfg;
    try {
        cfg = JSON.parse(configEl.textContent);
    } catch {
        throw new Error('qr-pay-modal: invalid qr-pay-modal-config');
    }
    const qr = QrPayCore.create();
    const $modal = $('#qrDonationModal');

    const SPINNER_HTML =
        '<div class="d-flex justify-content-center py-3">' +
        '<div class="spinner-border text-primary" role="status">' +
        '<span class="sr-only">Loading…</span>' +
        '</div></div>';

    function openQrPayModal() {
        $modal.find('#code_scanned, #continue_on_mobile, #countdown').hide();
        $modal.find('#qrcode').html(SPINNER_HTML);
        $modal.modal('show');

        qr.start({
            saveUrl: cfg.routes.saveQrCodeInfo,
            checkUrl: cfg.routes.qrCheckOpened,
            donationData: cfg.donationData,
            onQrReady: function (qrHtml, debugUrl) {
                $modal.find('#qrcode').html(qrHtml);
                if (cfg.showDebugUrl) $modal.find('#qrcode_url').html(debugUrl);
            },
            onScanned: function () {
                $modal.find('#code_scanned, #continue_on_mobile, #countdown').show();
            },
            onTick: function (secsLeft) {
                $modal.find('#countdown_timer').text(secsLeft);
            },
            onComplete: function () {
                localStorage.clear();
                cleanupBootstrapModalBody();
                memberLogOut();
            },
            onError: function (msg) {
                closeQrPayModal();
                showAlertMsg(msg || 'There was an error creating the QR Code link, please try again', 'danger');
            },
        });
    }

    function closeQrPayModal() {
        qr.stop();
        hideOverlay(getMemberOverlayElement());
        $modal.modal('hide');
    }

    document.querySelectorAll('[data-qr-modal-close]').forEach(function (el) {
        if (typeof el.__qrPayClose === 'function') {
            el.removeEventListener('click', el.__qrPayClose);
        }
        el.__qrPayClose = function (e) {
            e.preventDefault();
            closeQrPayModal();
        };
        el.addEventListener('click', el.__qrPayClose);
    });

    qrPayModal = {
        open: openQrPayModal,
        close: closeQrPayModal,
    };
}
